export default __webpack_public_path__ + "static/media/GetInvolvedGraphic1.70b213a3.png";